import PropTypes from "prop-types";

import ChartBase from "@/components/Elements/Charts/ChartBase";

import { useHistogramChartOptions } from "./useHistogramChartOptions";

const HistogramChart = ({
  data = [],
  categoriesTitle,
  valuesTitle,
  formatCategoryLabel = (category) => category,
  formatValueLabel = (value) => value,
  formatTooltipValue = (value) => value,
  controlled,
  onSelectedCategoryChange,
  ...chartBaseProps
}) => {
  const options = useHistogramChartOptions({
    data,
    categoriesTitle,
    valuesTitle,
    formatCategoryLabel,
    formatValueLabel,
    formatTooltipValue,
    controlled,
  });

  const onSelectChange = ({ selected }) => {
    // We are in selectedMode = 'single', so let's just pick the first selected value
    onSelectedCategoryChange?.(selected[0]);
  };

  return (
    <ChartBase
      {...chartBaseProps}
      options={options}
      onSelectChange={onSelectChange}
    />
  );
};

HistogramChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  categoriesTitle: PropTypes.string,
  valuesTitle: PropTypes.string,
  formatCategoryLabel: PropTypes.func,
  formatValueLabel: PropTypes.func,
  formatTooltipValue: PropTypes.func,
  onSelectedCategoryChange: PropTypes.func,
  controlled: PropTypes.shape({
    selectedCategory: PropTypes.string,
  }),
};

export default HistogramChart;
